module.exports = __webpack_public_path__ + "assets/partners-bg-0.5x.93417367.webp";